import IconArrowLeft from "@/app/(site)/_components/Atoms/Icons/IconArrowLeft"
import IconArrowRight from "@/app/(site)/_components/Atoms/Icons/IconArrowRight"
import { ImageSize } from "@/types/centra/checkout-api/products/post-products"
import Image from "next/image"
import React, { useEffect, useState } from "react"
import Text from "../../../../Atoms/Text"

type QuickShopImageCarouselProps = {
    images: {
        mini: ImageSize[]
        small: ImageSize[]
        standard: ImageSize[]
        big: ImageSize[]
        full: ImageSize[]
    }[]
    selectedImage: number
    productName: string
}

const getImageSrc = (
    width: number,
    sources: {
        mini: ImageSize[]
        small: ImageSize[]
        standard: ImageSize[]
        big: ImageSize[]
        full: ImageSize[]
    }
): string => {
    if (width <= 500) {
        return sources?.small?.[0]?.url
    } else if (width <= 1280) {
        return sources?.standard?.[0]?.url
    } else {
        return sources?.big?.[0]?.url
    }
}

const QuickShopImageCarousel: React.FC<QuickShopImageCarouselProps> = ({
    images,
    selectedImage,
    productName
}) => {
    const [currentImage, setCurrentImage] = useState(selectedImage)
    const [imageSrc, setImageSrc] = useState("")

    const updateImageSrc = () => {
        if (typeof window !== "undefined") {
            setImageSrc(getImageSrc(window.innerWidth, images[currentImage]))
        }
    }

    useEffect(() => {
        updateImageSrc()
        const handleResize = () => updateImageSrc()

        if (typeof window !== "undefined") {
            window.addEventListener("resize", handleResize)
        }

        return () => {
            if (typeof window !== "undefined") {
                window.removeEventListener("resize", handleResize)
            }
        }
    }, [currentImage, images])

    const goToPrevious = () =>
        setCurrentImage(prev => (prev > 0 ? prev - 1 : images.length - 1))
    const goToNext = () =>
        setCurrentImage(prev => (prev < images.length - 1 ? prev + 1 : 0))

    return (
        <div
            className="z-50 flex w-full items-center justify-center bg-white"
            aria-label={`Image carousel for ${productName}`}
        >
            <Text
                size="small"
                weight="regular"
                className="absolute left-16 top-16 z-50"
            >{`${currentImage + 1} / ${images.length}`}</Text>
            <div className="flex w-full items-center justify-center">
                {imageSrc && (
                    <div className="mb-16 aspect-square overflow-hidden">
                        <Image
                            src={imageSrc}
                            alt={`image ${currentImage}`}
                            fill
                            className={"object-contain"}
                        />
                    </div>
                )}

                {images.length > 1 && (
                    <div className="absolute top-1/2 flex w-full justify-between">
                        <button
                            onClick={goToPrevious}
                            className="z-50 p-16"
                            aria-label="Previous image"
                        >
                            <IconArrowLeft className="h-16 w-16 text-black" />
                        </button>
                        <button
                            onClick={goToNext}
                            className="z-50 p-16"
                            aria-label="Next image"
                        >
                            <IconArrowRight className="h-16 w-16 text-black" />
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}

export default QuickShopImageCarousel
